import React from 'react';
import { ExpandableContainer } from 'components';
import {
  Button,
  DatePicker,
  Input,
  Select,
} from 'antd';
import { styles } from '../styles';

const ProductSearch = () => {
  const formItem = [
    {
      label: '업체명',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="업체명을 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '발주일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '카테고리',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '카테고리1', value: '카테고리1' },
                  { label: '카테고리2', value: '카테고리2' },
                  { label: '카테고리3', value: '카테고리3' },
                  { label: '카테고리4', value: '카테고리4' },
                  { label: '카테고리5', value: '카테고리5' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'카테고리 선택'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '주문번호',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="주문번호를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '상품명',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="상품명을 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
            </>
          ),
        },
      ],
    },
    /* {
      label: '진열 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'진열함'}>진열함</Radio>
                <Radio value={'진열안함'}>진열안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'판매함'}>판매함</Radio>
                <Radio value={'판매안함'}>판매안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    }, */
  ];

  return (
    <ExpandableContainer borderRadius={4} padding={20}>
      {formItem.map((_item, _index) => (
        <div
          key={`form_${_index}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 0px',
          }}
        >
          <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
            <label>{_item.label}</label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {_item.form.map((_subitem, _subkey) => (
              <React.Fragment key={`input_${_subkey}`}>
                {_subitem.input}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </ExpandableContainer>
  )
}

export default ProductSearch;